// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ab65ebf1","545":"c915901e","787":"0bda5566"}[chunkId] + ".chunk.js";
};